import { apiClient } from "@/lib/apiClient";
import type { IVisualAnalysisResponse } from "./interfaces";

export const getVisualAnalysis = async (): Promise<IVisualAnalysisResponse> => {
  const { data } = await apiClient.get<IVisualAnalysisResponse>(
    "/data/visual-analysis",
  );
  return data;
};
